import { inject, injectable } from "inversify";
import { BudgetRepository } from "@project/data/repositories/budget.repository";

@injectable()
export class DeleteJustificationTemplateUseCase {
    constructor(
        @inject(BudgetRepository)
        private readonly budgetRepository: BudgetRepository,
    ) { }

    async execute(templateId: number): Promise<void> {
        await this.budgetRepository.deleteJustificationTemplate(templateId);
    }
}
